import { makeEventsPair, AnalyticsEventsPair } from "./AnalyticsEventBuilder";
import { Game } from "../../models/Game";
import { GamesAnalyticsAi } from "./AI/GamesAnalyticsAi";
import { GamesAnalyticsGa } from "./GA/GamesAnalyticsGa";

export class GamesAnalytics {
  gaAnalytics = new GamesAnalyticsGa();
  aiAnalytics = new GamesAnalyticsAi();

  gameStart(game: Game, isTheaterMode: boolean): AnalyticsEventsPair {
    window.parent.document.dispatchEvent(
      new CustomEvent("bh_games_events", {
        detail: {
          event: "game|play|start|success",
          module: {
            id: this.getGameId(game.id),
            session: this.getSession(),
            locale: this.getLocale(),
          },
        },
      })
    );
    return makeEventsPair(
      this.gaAnalytics.gameStart(game),
      this.aiAnalytics.gameStart(game, isTheaterMode)
    );
  }

  gameEnd(
    game: Game,
    duration: number,
    score: number,
    isTheaterMode: boolean
  ): AnalyticsEventsPair {
    window.parent.document.dispatchEvent(
      new CustomEvent("bh_games_events", {
        detail: {
          event: "game|play|finish|success",
          module: {
            id: this.getGameId(game.id),
            session: this.getSession(),
            locale: this.getLocale(),
          },
        },
      })
    );
    return makeEventsPair(
      this.gaAnalytics.gameEnd(game, duration),
      this.aiAnalytics.gameEnd(game, duration, score, isTheaterMode)
    );
  }

  getGameId(gameId: string) {
    return "ARK-GAME-" + gameId;
  }

  getSession() {
    let timeStampMs: string = new Date().getTime().toString();
    return "AARP-ARK-GAME-" + timeStampMs;
  }

  getLocale() {
    let isSpanishLocale = window.navigator.language.includes("es");
    return isSpanishLocale ? "ES" : "EN";
  }

  prerollStart(game: Game): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.prerollStart(game));
  }

  prerollEnd(game: Game, duration: number): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.prerollEnd(game, duration));
  }

  playAgainClick(game: Game): AnalyticsEventsPair {
    return makeEventsPair(
      this.gaAnalytics.playAgainClick(game),
      this.aiAnalytics.playAgainClick(game)
    );
  }

  playAgainImpressions(game: Game): AnalyticsEventsPair {
    return makeEventsPair(this.gaAnalytics.playAgainImpressions(game), null);
  }

  performanceMeasure(game: Game, pe: PerformanceEntry): AnalyticsEventsPair {
    return makeEventsPair(null, this.aiAnalytics.performanceMeasure(game, pe));
  }

  theaterModeClick(game: Game, isTheaterMode: boolean): AnalyticsEventsPair {
    return makeEventsPair(
      null,
      this.aiAnalytics.theaterModeClick(game, isTheaterMode)
    );
  }

  gameEndShareClick(game: Game): AnalyticsEventsPair {
    return makeEventsPair(
      this.gaAnalytics.gameEndShareClick(game),
      this.aiAnalytics.gameEndShareClick(game)
    );
  }

  gameEndEngagementPromoClick(game: Game): AnalyticsEventsPair {
    return makeEventsPair(
      this.gaAnalytics.gameEndEngagementPromoClick(game),
      this.aiAnalytics.gameEndEngagementPromoClick(game)
    );
  }

  gameEndCrossPromotionClick(game: Game): AnalyticsEventsPair {
    return makeEventsPair(
      this.gaAnalytics.gameEndCrossPromotionClick(game),
      this.aiAnalytics.gameEndCrossPromotionClick(game)
    );
  }
}
